import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  // {
  //   path: '/',
  //   name: 'Home',
  //   component: Home
  // },
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // },
  {
    path: '/',
    redirect: '/pdf'
  },
  {
    path: '/pdf',
    component: () => import(/* webpackChunkName: "waha" */ '../views/SOTL/PDFScanner/Layout.vue'),
    children: [
      {
        path: '',
        redirect: '/pdf/home'
      },
      {
        path: 'home',
        component: () => import(/* webpackChunkName: "waha" */ '../views/SOTL/PDFScanner/Home.vue')
      },
      {
        path: 'login',
        component: () => import(/* webpackChunkName: "waha" */ '../views/SOTL/PDFScanner/Login.vue')
      },
      {
        path: 'dash',
        beforeEnter: async (to, from, next) => {
          const API = await import('../views/SOTL/Kit/pdfAPI.js')
          if (await API.checkLogin()) {
            next()
          } else {
            next('/')
          }
        },
        component: () => import(/* webpackChunkName: "waha" */ '../views/SOTL/PDFScanner/Dashboard.vue')
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
